import Vue from 'vue'
import './configs/default-configs'
import './utils/scripts/CCBaseScript'
import './utils/scripts/scrollPage'
import './utils/scripts/globalScript'
import './utils/hooks/useGlobalLoading'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'

// Global Components
import './global-components'

import { renderSanitized, sanitizeHtml } from '@/utils/sanitize-html'

// ใช้แทน v-html ทุกที่ที่ผูกกับ HTML ที่มาจาก API
// รับ HTML มาตรฐานได้เหมือน v-html แต่ตัด script, event handler
// และ URL อันตรายออกก่อนเขียนลง DOM
Vue.directive('safe-html', (el, binding) => {
  renderSanitized(el, binding.value)
})

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'
import { ToastPlugin, ModalPlugin, BootstrapVue } from 'bootstrap-vue'
import vSelect from 'vue-select'
import VueQuillEditor, { Quill } from 'vue-quill-editor'

// Axios Mock Adapter
import '@/@fake-db/db' // For form-wizard

// Global Custom Components
import OverlayLoading from '@/views/components/loading/OverlayLoading.vue';
import SpinnerLoading from '@/views/components/loading/SpinnerLoading.vue';
import ImageUploader from './@core/components/image-uploader/ImageUploader.vue';
import CardNoItem from './@core/components/card-no-item/CardNoItem.vue';
import CancelButton from './views/components/button/CancelButton.vue';
import SaveButton from './views/components/button/SaveButton.vue';
import AddButton from './views/components/button/AddButton.vue';
import GlobalButton from './views/components/button/GlobalButton.vue';
import BaseModal from './@core/components/base-modal/BaseModal.vue';
import StepNavbar from './views/components/step-navbar/StepNavbar.vue';
import { sortableRow, sortableCol } from '@/views/components/base-table/hooks/directive';
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/css/swiper.css'

import App from './App.vue'
import store from './store'
import router from './router'

// vue-quill-editor require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Flag from 'vue-flagpack'

Vue.use(Flag, {
  name: 'Flag'
}) 

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(BootstrapVue)

// Composition API
Vue.use(VueCompositionAPI)
Vue.use(VueAwesomeSwiper)
Vue.component('v-select', vSelect)
Vue.component('base-modal', BaseModal)
Vue.component('save-button', SaveButton)
Vue.component('cancel-button', CancelButton)
Vue.component('add-button', AddButton)
Vue.component('global-button', GlobalButton)
Vue.component('image-uploader', ImageUploader)
Vue.component('card-no-item', CardNoItem)
Vue.component('step-navbar', StepNavbar)
Vue.component('overlay-loading', OverlayLoading)
Vue.component('spinner-loading', SpinnerLoading)

// v-safe-html กันได้แค่ฝั่งแสดงผล แต่หน้าแก้ไขโหลด HTML เข้า Quill โดยตรง
// Quill 1.3.7 แปลง HTML ด้วย clipboard.convert() ซึ่งเขียนลง
// container.innerHTML ของ element ที่ต่ออยู่กับ document จริง (quill.js:8944)
// <img onerror> ที่ถูกบันทึกไว้ใน DB จึงรันทันทีที่แอดมินเปิดหน้าแก้ไข
// convert() เป็นทางผ่านเดียวของ HTML ที่เข้า editor ทุกเส้นทาง
// (watcher -> setContents, pasteHTML, dangerouslyPasteHTML) จึงกรองที่จุดนี้จุดเดียว
const QuillClipboard = Quill.import('modules/clipboard')
class SafeClipboard extends QuillClipboard {
  convert(html) {
    // เรียกแบบไม่มี argument คือแปลงเนื้อหาที่อยู่ใน container อยู่แล้ว ต้องปล่อยผ่าน
    return super.convert(typeof html === 'string' ? sanitizeHtml(html) : html)
  }
}
Quill.register('modules/clipboard', SafeClipboard, true)

Vue.use(VueQuillEditor /* { default global options } */)
function contentWatchOverride(newVal, oldVal) {
  if (this.quill) {
    if (newVal && newVal !== this._content) {
      this._content = newVal
      const delta = this.quill.clipboard.convert(newVal)
      this.quill.setContents(delta)
    } else if (!newVal) {
      this.quill.setText('')
    }
  }
}

const Base = Vue.options.components['quill-editor']
const CustomQuillEditor = Base.extend({
  beforeCreate() {
    Vue.set(this.$options.watch, 'content', contentWatchOverride.bind(this))
    Vue.set(this.$options.watch, 'value', contentWatchOverride.bind(this))
  },
})

Vue.component('custom-quill-editor', CustomQuillEditor)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/css/main.css')
require('@/assets/scss/style.scss')

// Feather font icon - For form-wizard
require('@core/assets/fonts/feather/iconfont.css')

Vue.config.productionTip = false

//Custom Directive
Vue.directive('sortableRow', sortableRow);
Vue.directive('sortableCol', sortableCol);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
